
import { registerSW } from 'virtual:pwa-register'

const updateSW = registerSW({
  onNeedRefresh() {
    document.dispatchEvent(
      new CustomEvent('softwareUpdated', { detail: updateSW })
    )
  },
  onRegisterError(error) {
    console.error('Error during service worker registration:', error)
  },
  immediate: true
})
